


















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import topStep from "@/components/faceCoupon/topStep.vue";
import topTitle from "@/components/faceCoupon/topTitle.vue";

const faceIntegralModule = namespace("faceIntegral");
@Component({
  components: {
    topStep,
    topTitle
  }
})
export default class FaceIntegral extends Vue {
  titleName: string = "面对面积分";
  /* 步骤 */
  stepsArry: Object = [
    { num: 1, name: "查询会员", class: "active" },
    { num: 2, name: "确认身份", class: "" },
    { num: 3, name: "为会员积分", class: "" },
    { num: 4, name: "完成", class: "" }
  ]; 
  searchVal: string = ""; /* 输入会员卡号/手机号 */
  searchIntegral() {
    if (this.searchVal == "") {
      (this as any).$dialog.alert({ message: "请输入会员卡号/手机号" });
      return false;
    }
    this.$toast.loading({
      message: '',
      forbidClick: true,
      duration: 1200
    })
    // let reg = /^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
    /**会员查询类型searchType:1:mobile 3:cardNo 4:openId 6:username 7:cid*/
    this.$store.dispatch("faceIntegral/getMemberDetail", {
      searchText: this.searchVal,
      searchType: 1
    });
  }
  mounted() {
    (this as any).$wechartfunc();
  }
  async scancode() {
    const scanQRCode: any = await (this as any).$wechartfunc("scanQRCode");
    console.log(scanQRCode);
    if (scanQRCode) {
      console.log(scanQRCode);
      this.$store.dispatch("faceIntegral/getMemberDetailByQrCode", {
        searchText: scanQRCode,
        searchType: 3
      });
    } else {
      return this.$toast("无此会员");
    }

    // const wx: any = (window as any).wx;
    // const _this: any = this;
    // wx.scanQRCode({
    //   needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    //   scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
    //   success: function(res: any) {
    //     this.searchVal = res.resultStr;
    //     if (res.resultStr) {
    //       this.$store.dispatch("faceCoupon/getMemberDetail", {
    //         searchText: this.searchVal,
    //         searchType: 3
    //       });
    // } else {
    //   return Toast("没有获取到会员码");
    // }
    //   }
    // });
  }
}
